module.exports = __webpack_public_path__ + "img/bar.d986c2c2.svg";